import {useMutation, useQueryClient} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {DeleteFavoriteAddressServiceParams} from '../types';
import {deleteFavoriteAddress} from '../services/deleteFavoritePlace';

export function useDeleteFavoriteAddressMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({sequence, signal}: DeleteFavoriteAddressServiceParams) =>
			deleteFavoriteAddress({sequence, signal}),
		onSuccess: () => {
			queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROFILE_FAVORITE_ADDRESSES]});
		},
	});
}
